// A short, hand-picked list of OpenRouter models for the Settings > AI card. Any other model id
// still works through "Other model" (the backend accepts any valid OpenRouter id).
// An empty value means the app default (DEFAULT_AI_MODEL).
// Prices are USD per 1 million tokens (input / output), checked against openrouter.ai on 2026-10-29.
// They are a guide only: OpenRouter sets the real price, so re-check the ids when models are retired.
export const DEFAULT_AI_MODEL = 'openai/gpt-4o-mini';

export const AI_MODELS = [
  { value: '', label: 'Recommended - GPT-4o mini ($0.15 / $0.60 per 1M tokens)' },
  { value: 'anthropic/claude-haiku-5.5', label: 'Claude Haiku 5.5 - fast, low cost ($0.10 / $0.50)' },
  { value: 'google/gemini-3.7-flash', label: 'Gemini 3.7 Flash - balanced ($0.75 / $3.75)' },
  { value: 'anthropic/claude-sonnet-5.5', label: 'Claude Sonnet 5.5 - best writing ($2 / $10)' },
  { value: 'anthropic/claude-opus-5.5', label: 'Claude Opus 5.5 - premium ($4 / $20)' },
];

export const OTHER_MODEL = '__other__';

// What the dropdown should show for a saved model id.
export const modelSelectValue = (saved, otherChosen = false) => {
  const value = saved || '';
  if (otherChosen) return OTHER_MODEL;
  return AI_MODELS.some((m) => m.value === value) ? value : OTHER_MODEL;
};
